import React from 'react';

export interface StepProps {
    number: string;
    title: string;
    description: string;
}

export const Step: React.FC<StepProps> = ({ number, title, description }) => {
    return (
        <div className="text-left flex items-start space-x-6">
            <div
                style={{
                    background: `linear-gradient(197.13deg, rgba(53, 67, 161, 0.45) 11.78%, rgba(255, 255, 255, 0.2025) 95.48%)`
                }}
                className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full  text-[#000000] font-bold text-lg">
                {number}
            </div>
            <div>
                <h3 className="text-xl font-[500] text-[#1C2347] mb-1">{title}</h3>
                <p className="text-[#6B6B6B] text-[16px]">{description}</p>
            </div>
        </div>
    );
};